function browserSupportsAllFeatures() {
    return (typeof Promise !== "undefined" && Promise.toString().indexOf("[native code]") !== -1) && (typeof fetch !== "undefined" && fetch.toString().indexOf("[native code]") !== -1);
}

if (!browserSupportsAllFeatures()) {
    require('es6-promise').polyfill();
    require('isomorphic-fetch');
}
const regionApi = "/api/regions/";
const dealerApi = "/api/dealers/";

const pageId = document.getElementById('pageId').text;
const language = document.getElementById('language').value;

function validateResponse(response) {
    if (!response.ok) {
        throw Error(response.statusText);
    }
    return response;
}

function readResponseAsJson(response) {
    return response.json();
}

function logError(error) {
    console.log("Error fetching data \n", error);
}

async function getRegions() {
    var result = await fetch(regionApi + "?pageId=" + pageId + "&language=" + language)
        .then(validateResponse)
        .then(readResponseAsJson)
        .catch(logError);
    return result;
}

async function getRegion(regionId) {
    var result = await fetch(regionApi + regionId + '/dealers')
        .then(validateResponse)
        .then(readResponseAsJson)
        .catch(logError);
    return result;
}

async function getDealer(dealerId) {
    var result = await fetch(dealerApi + dealerId)
        .then(validateResponse)
        .then(readResponseAsJson)
        .catch(logError);
    return result;
}

export {getRegions, getRegion, getDealer};